import { useStore } from '@betgames/bg-state-manager';
import { GamesContexts } from '@bg-shared/contexts/Games';
import { ISelectedBettingOption } from '@bg-shared/interfaces/IBettingOption';
import { useMatchedGameId } from '@bg-shared/hooks/useGameId';
import { formatSimpleOption } from '../utils/formatSimpleOption';
import { selectedGamesSelectors } from '../selectedGames.selectors';
import { selectedGames } from '../main';

export const useGetSelectedOptions = (): ISelectedBettingOption[] => {
    const gameId = useMatchedGameId();
    const selected = useStore(selectedGames.store, selectedGamesSelectors.getOptions(gameId));
    const games = GamesContexts.useGamesDataForBetslip();

    return selected.map((option) => formatSimpleOption(games[option.gameId], option));
};
